import React, { Component } from "react";
import s from "./styles.scss";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import {
  Inputs,
  Buttons,
  formConfig
} from "./ReporteCoordinadorAdministrativo.form";
import { MemoTable } from "./ReporteCoordinadorAdministrativo.table";
import { ReporteCoordinadorAdministrativoStore } from "../../../containers/comisionesCoordinadorAdministrativo/reporte/ReporteCoordinadorAdministrativo.store";
import { ReporteCoordinadorAdministrativoDispatcher } from "../../../containers/comisionesCoordinadorAdministrativo/reporte/ReporteCoordinadorAdministrativo.dispatcher";
import { errorNotification } from "../../../../utils/notifications";
import { Styled } from "../../../../toolkit/decorators/Artifact";
import { getComisionesByPeriodoReporte } from "../../../actions/comisionCoordinadorAdministrativo";

interface Props
  extends ReporteCoordinadorAdministrativoStore,
    ReporteCoordinadorAdministrativoDispatcher {}

interface State {
  periodo: string;
  downloading: boolean;
}

@Styled(s)
export default class ReporteCoordinadorAdministrativoComponent extends Component<
  Props,
  State
> {
  state = {
    periodo: "",
    downloading: false
  };

  submit = async (values: any) => {
    const anio = values.anio || new Date().getFullYear();
    const mes = values.mes.toString().padStart(2, "0");
    const periodo = `${anio}-${mes}-01`;

    this.setState({ periodo: periodo });

    const preview = await this.props.getComisionesPorPeriodo(periodo);

    if (!preview.fulfilled) {
      errorNotification(
        preview.gettingComisionesError || "Error al consultar las comisiones"
      );
    }
  };

  render() {
    const { comisiones, gettingComisiones } = this.props;

    return (
      <div className="container">
        <div className="row mt-3">
          <div className="col-12">
            <FormBuilder<Inputs, Buttons>
              config={formConfig}
              submit={this.submit}
              processing={gettingComisiones}
            />
          </div>
        </div>

        {comisiones && comisiones.length > 0 && (
          <div className="row">
            <div className="col-12">
              <MemoTable
                data={comisiones}
                loading={gettingComisiones || this.state.downloading}
                onExport={() => {
                  this.setState({ downloading: true });
                  getComisionesByPeriodoReporte(this.state.periodo, () =>
                    this.setState({ downloading: false })
                  );
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
